// const fs = require("fs");
// const os = require("os");
// let jsonMeta = JSON.parse(
//     fs.readFileSync(".\\public\\library\\metadata.json", "utf8")
// ).StudyStructure.ElmtDefs.Study;
// fs.readFileSync(".\\public\\library\\meta_efc14112.json", "utf8")
// )
// let efc14112 = JSON.parse(
//     fs.readFileSync(".\\public\\library\\efc14113.json", "utf8")
// ).FullStudiesResponse.FullStudies[0].Study;
module.exports = { compareTrial };

function isObject(obj) {
  return obj !== null && typeof obj === "object";
}
function isUndef(v) {
  return v === undefined || v === null;
}
function compareTrial(strStudyID, jsonStandard, jsonStudy) {
  strStudyID = strStudyID || "Study";
  let temp = JSON.parse(JSON.stringify(jsonStandard));
  //   let tree={};\
  // console.log(jsonStudy);

  function traverser(temp, node) {
    if (Array.isArray(temp)) {
      for (let i = 0; i < temp.length; i++) {
        let branch = temp[i];

        traverser(branch, node);
      }
    } else {
      let value = node[temp.name];

      if (isUndef(value)) return;
      else {
        let children = temp.children;
        if (temp.children) {
          if (Array.isArray(value)) {
            // console.log(temp.name);
            // console.log(value);
            temp["comparison"] = temp["comparison"] || {};
            temp["comparison"][strStudyID] = value;
          } else {
            traverser(children, value);
          }
        } else if (typeof value == "object") {
          traverser(temp, value);
        } else {
          temp["comparison"] = temp["comparison"] || {};
          temp["comparison"][strStudyID] = value;
        }
      }
    }
  }
  if (temp) {
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].name === "protocolSection") {
        result = temp[i].children;
        traverser(temp[i].children, jsonStudy);
        break;
      }
    }
  }
  return temp;
}
